<template>
  <vs-row
    vs-type="flex"
    vs-justify="space-between"
    vs-w="12">
    <vs-col
      class="vs-pagination--mb"
      vs-type="flex"
      vs-justify="flex-start"
      vs-align="center"
      vs-lg="6"
      vs-sm="12"
      vs-xs="12" >
      <div v-if="description">
        <span
          style="margin-right:5px"
        >
          {{ descriptionTitle }}: {{ minRows }} - {{ maxRows }} {{ descriptionConnector }} {{ sizeArray }} | {{ descriptionBody }}:

        </span>
        <ul class="vs-pagination--array">
          <li
            v-for="(row,index) in descriptionItems"
            :key="index">
            <span
              :style="styleDescription"
              :class="[`vs-description-${color}`,{ 'vs-pagination--bold': (index==indexRows)}]"
              @click="changeRowMaxItems(index)">
              {{ row }}
            </span>
            <span
              v-if="index != (descriptionItems.length - 1)">
              ,
            </span>
          </li>
        </ul>
      </div>
    </vs-col>
    <vs-col
      class="vs-pagination--mb"
      vs-type="flex"
      vs-justify="flex-end"
      vs-align="center"
      vs-lg="6"
      vs-sm="12"
      vs-xs="12" >
      <div
        :style="stylePagination"
        :class="[`vs-pagination-${color}`]"
        class="con-vs-pagination">
        <nav class="vs-pagination--nav">
          <!-- 첫 페이지로 이동 -->
          <button
            :class="{disabled:current <= 1 ? 'disabled' : null}"
            :disabled="current === 1"
            class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
            @click="goTo(1)">
            <feather-icon icon="ChevronsLeftIcon" style="width: 16px"></feather-icon>
          </button>

          <!-- 이전 페이지로 이동 -->
          <button
            :class="{disabled:current <= 1 ? 'disabled' : null}"
            :disabled="current === 1"
            class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
            @click="prevPage">
            <feather-icon icon="ChevronLeftIcon" style="width: 16px"></feather-icon>
          </button>

          <!-- 모바일용 페이지 입력 -->
          <div v-if="goto" class="vs-pagination--input-container mobile-only">
            <input
              v-model="go"
              :max="total"
              class="vs-pagination--input-goto text-center"
              style="background-color: rgba(var(--vs-secondary), 1); color: #fff;"
              min="1"
              type="number"
              @change="goTo">
            <span class="vs-pagination--total-pages">/ {{ total }}</span>
          </div>

          <ul class="vs-pagination--ul desktop-only">
            <li
              v-for="(page, index) in pages"
              :key="index"
              :class="{'is-current': page == current}"
              class="item-pagination vs-pagination--li"
              @click="goTo(page)">
              <span>
                {{ page }}
              </span>
              <div class="effect"></div>
            </li>
          </ul>

          <!-- 데스크톱용 페이지 입력 -->
          <div v-if="goto" class="vs-pagination--input-container desktop-only">
            <input
              :value="current"
              :max="total"
              class="vs-pagination--input-goto text-center"
              style="background-color: rgba(var(--vs-secondary), 1); color: #fff;"
              min="1"
              type="number"
              @change="goTo">
            <span class="vs-pagination--total-pages">/ {{ total }}</span>
          </div>

          <!-- 다음 페이지로 이동 -->
          <button
            :class="{disabled:current === total ? 'disabled' : null}"
            :disabled="current === total"
            class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
            @click="nextPage">
            <feather-icon icon="ChevronRightIcon" style="width: 16px"></feather-icon>
          </button>

          <!-- 마지막 페이지로 이동 -->
          <button
            :class="{disabled:current === total ? 'disabled' : null}"
            :disabled="current === total"
            class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
            @click="goTo(total)">
            <feather-icon icon="ChevronsRightIcon" style="width: 16px"></feather-icon>
          </button>
        </nav>
      </div>
    </vs-col>
  </vs-row>
</template>
<script>
import _color from './color.js'

export default {
  name: 'KPagination',
  props:{
    color:{
      type:String,
      default:'primary'
    },
    total:{
      type:Number,
      required:true
    },
    sizeArray:{
      type:Number,
      required:false
    },
    maxItems: {
      type:[Number, String],
      required:false
    },
    value:{
      type:Number,
      required:true,
      default: 1
    },
    /**
     * @description 한 번에 보이는 페이지의 개수
     */
    max:{
      type:Number,
      default: 11
    },
    goto:{
      type:Boolean,
      default: true
    },
    type:{
      type:String
    },
    prevIcon:{
      type:String,
    },
    nextIcon:{
      type:String,
    },
    iconPack:{
      type:String,
      default:'feather'
    },
    description:{
      default: false,
      type: Boolean
    },
    descriptionItems:{
      default: () => [],
      type: Array
    },
    descriptionTitle: {
      type:String,
      default:'Registries'
    },
    descriptionConnector: {
      type:String,
      default:'of'
    },
    descriptionBody: {
      type:String,
      default:'Pages'
    },
  },
  data: () => ({
    pages: [],
    current: 0,
    go: 0,
    prevRange: '',
    nextRange: '',
    hoverBtn1: false,
    minRows: 0,
    maxRows: 0,
    indexRows: 0,
    windowWidth: window.innerWidth,
  }),
  computed: {
    defaultNextIcon() {
      if(this.$vs.rtl) return 'chevron_left'
      return 'chevron_right'
    },
    defaultPrevIcon() {
      if(this.$vs.rtl) return 'chevron_right'
      return 'chevron_left'
    },
    stylePagination () {
      let style = {}
      if (!_color.isColor(this.color)) {
        style = {
          '--vs-color-pagination': _color.getColor(this.color),
          '--vs-color-pagination-alpha': _color.getColor(this.color,.5)
        }
      }
      return style
    },
    styleDescription () {
      return {
        'cursor': 'pointer',
      }
    },
    responsiveMax() {
      // 화면 너비에 따라 최대 페이지 수를 조정
      if (this.windowWidth < 640) return 5 // xs
      if (this.windowWidth < 768) return 7 // sm
      if (this.windowWidth < 1024) return 9 // md
      return this.max // lg 이상
    }
  },
  watch: {
    current(val) {
      this.go = val  // 모바일 입력폼 동기화
      this.getPages()
      this.calculateMinMax(val)
      this.$emit('change', this.current)
    },
    total() {
      this.getPages()
    },
    max() {
      this.getPages()
    },
    value(val) {
      const pageNum = val < 1 ? 1 : (val <= this.total ? val : this.total)
      if (this.current !== pageNum) this.current = pageNum

      // 부모가 내려준 값을 그대로 다시 emit 하면 부모는 그것을 사용자 클릭과 구분하지 못한다.
      // 목록 화면에서는 이 재emit 이 router.push 를 중복시켜 Navigation cancelled 를 만든다.
      // 범위를 벗어나 보정한 경우에만 보정값을 알려준다(total 이 아직 0 인 초기 렌더는 제외).
      // current 변경은 감시자를 통해 change 로 그대로 전달되므로 @change 사용처는 영향이 없다.
      if (this.total > 0 && Number(pageNum) !== Number(val)) this.$emit('input', pageNum)
    },
  },

  async mounted () {
    this.current = this.go = this.value
    await this.calculateMinMax(this.current)
    this.indexRows = this.descriptionItems.indexOf(this.maxItems)
    this.getPages()

    // Add resize event listener
    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy() {
    // Remove resize event listener
    window.removeEventListener('resize', this.handleResize)
  },

  methods:{
    async changeRowMaxItems (index) {
      this.indexRows = index
      await this.$emit('changeMaxItems', index)
      await this.calculateMinMax(this.current)
      this.current = 1
      this.$emit('input', this.current)
    },
    async calculateMinMax (val) {
      this.maxRows = ( (val * this.maxItems) <= this.sizeArray ) ? val * this.maxItems : this.sizeArray
      this.minRows = ( (val * this.maxItems) <= this.sizeArray ) ? (this.maxRows - this.maxItems) + 1 : ((this.current - 1) * this.maxItems) + 1
    },
    isEllipsis(page) {
      return page === '...'
    },
    goTo(page) {
      if(page === '...') {
        return
      }
      if (typeof page.target === 'undefined') {
        this.current = page
      } else {
        const value  = parseInt(page.target.value, 10)
        this.go      = (
          value < 1 ? 1 : (value <= this.total ? value : this.total)
        )
        this.current = this.go
      }
      this.$emit('input', this.current)
    },
    getPages() {
      const max = this.responsiveMax
      const total = this.total
      const current = this.current
      const pages = []
      const half = Math.floor(max / 2)

      let start = current - half
      let end = current + half

      if (start < 1) {
        start = 1
        end = Math.min(max, total)
      }

      if (end > total) {
        end = total
        start = Math.max(1, total - max + 1)
      }

      for (let i = start; i <= end; i++) {
        pages.push(i)
      }

      this.pages = pages
    },
    nextPage() {
      if(this.current < this.total) {
        this.current++
      }
      this.$emit('input', this.current)
    },
    prevPage() {
      if(this.current > 1) {
        this.current--
      }
      this.$emit('input', this.current)
    },
    handleResize() {
      this.windowWidth = window.innerWidth
      this.getPages()
    },
  }
}
</script>

<style lang="scss" scoped>
.vs-pagination--input-container {
  display: inline-flex;
  align-items: center;
  margin-left: 5px;
  white-space: nowrap;
}

.vs-pagination--total-pages {
  color: rgba(var(--vs-secondary), 1);
  margin-left: 2px;
  line-height: 1;
  white-space: nowrap;
}

.vs-pagination--input-goto {
  width: 40px;
  border: none;
  border-radius: 4px;
  padding: 0;
  text-align: center;
  -moz-appearance: textfield;
  line-height: 1;
  height: 24px;
  white-space: nowrap;
}

.vs-pagination--input-goto::-webkit-outer-spin-button,
.vs-pagination--input-goto::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@media (max-width: 640px) {
  .vs-pagination--input-container {
    margin-left: 2px;
  }

  .vs-pagination--input-goto {
    width: 35px;
    height: 22px;
  }

  .vs-pagination--total-pages {
    font-size: 0.9em;
  }
}

@media (max-width: 400px) {
  .vs-pagination--nav {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
  }

  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: inline-flex;
  }

  .vs-pagination--buttons {
    display: flex;
    align-items: center;
  }

  .vs-pagination--input-container {
    margin: 0 5px;
  }

  .vs-pagination--input-goto {
    width: 40px;
    height: 24px;
  }

  .vs-pagination--total-pages {
    font-size: 1em;
  }
}

@media (min-width: 401px) {
  .mobile-only {
    display: none;
  }

  .desktop-only {
    display: inline-flex;
  }
}
</style>
